import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormFreeSoloField from 'modules/ui/editform/fields/EditFormFreeSoloField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import EntriesListComponent from 'app/admin/model/component/EntriesListComponent';
import { useParams, withRouter } from 'react-router';
import ModelCalculate from 'app/admin/common/component/ModelCalculate';
import AnnModelEditService from '../service/AnnModelEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'annModelEditForm',
		topic: 'model',
		service: AnnModelEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }/*, { key: 'entries' }*/];
		},
		backLink: () => '/model',
		defaultValue: () => AnnModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('ann')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'image',
					component: EditFormFileInputField,
					required: true
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						value: null,
						minValue: null,
						maxValue: null,
						uom: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' },
								{ label: 'DistillationCurve', value: 'DistillationCurve' }
							]
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							type: 'MIN_MAX',
							minValueField: 'minValue',
							maxValueField: 'maxValue',
							disableCopyPaste: true,
							visibleIf: type => (type === 'ComponentMassFrac' || type === 'DistillationCurve')
						},
						{
							key: 'minValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'maxValue',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable' || type === 'SpreadSheet' || type === null,
							type: 'number'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							// dependsOn: 'type',
							// visibleIf: type => type === 'Variable'
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						uom: null,
						orderIndex: null,
						components: []
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' },
								{ label: 'DistillationCurve', value: 'DistillationCurve' }
							]
						},
						// {
						// 	key: 'components',
						// 	component: EditFormFreeSoloField,
						// 	required: true,
						// 	multiple: true,
						// 	query: () => new Promise(resolve => resolve([])),
						// 	dependsOn: 'type',
						// 	visibleIf: type => type === 'ComponentMassFrac'
						// },
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						}
					]
				}
			];

			return fields;
		}
	};
};

function AnnModelEditForm() {
	const { id, driverName } = useParams();
	const dispatch = useDispatch();

	const myConfig = config({ id, driverName });
	return (
		<EditFormPage
			config={myConfig}
			beforeSaveContent={<ModelCalculate id={id} type="model" />}
		// onSave={result => {
		// 	if (!result.engineSuccessful) dispatch(showMessage({ message: `Engine: ${result.engineMessage}` }));
		// }}
		/>
	);
}

export default withRouter(AnnModelEditForm);